import { StatusTag } from '../../../../components/index';

const wasteCollectionStatus = {
  yes: { label: 'Sim', className: 'green' },
  no: { label: 'Não', className: 'neutral-blue' },
  pending: { label: 'Pendente', className: 'orange' },
};

export function WasteCollectionStatusTag(props: {
  hasWasteCollection: boolean | null;
}) {
  const { hasWasteCollection } = props;

  let status = wasteCollectionStatus.pending;
  if (hasWasteCollection === true) status = wasteCollectionStatus.yes;
  if (hasWasteCollection === false) status = wasteCollectionStatus.no;

  return (
    <StatusTag>
      <span className={status.className}>{status.label}</span>
    </StatusTag>
  );
}
